import React, {Component} from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import {path, mergeDeepLeft, clone} from 'ramda';
import Input from '../../common/Input';
import Select from '../../common/Select';
import Breadcrumbs from '../../common/Breadcrumbs';
import '../../css/forms/default-forms.css';
import fields, {customers} from './fields';
import approve from 'approvejs';
import getPassword from '../../utils/getPassword';
import {linkDataToFields} from '../../utils/fields';
import {processFields} from '../../utils/prePost';
import {updateUser, fetchUserById, uploadUserPhoto, getUserPhotoThumbUrl, downloadUserThumbPhoto, removeUserPhoto} from '../../api/users';
import {findByField} from '../../utils/arrObj';
import '../../css/forms/default-forms.css';
import {fetchRolesList} from '../../api/roles';
import hasAccess from "../../helpers/permissionChecker";
import DynamicFormList from "../../common/DynamicFormList";
import {getList} from "../../api/projects";
import CKEditorComponent from "../../сomponents/CKEditor";
import UserPhoto from '../../common/UserPhoto';
import {fetchAllEmployees} from "../../api/employees";
import {AsyncCreatable} from "react-select";
import fetch2 from "cross-fetch";
import config from "../../config";
import store from "store2";
import {debounce} from "lodash";

export class PeopleEdit extends Component {

  constructor(props) {
    super(props);
    this.state = {
      submit: false,
      errors: [],
      fields: clone(fields),
      customer_remove_ids: [],
      customer_add_ids: []
    };
    this.submit = this.submit.bind(this);
    this.updateCustomerValue = this.updateCustomerValue.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.generatePassword = this.generatePassword.bind(this);
    this.changeFormValue = this.changeFormValue.bind(this);
    this.cancel = this.cancel.bind(this);
    this.fetchDataRouteById = this.fetchDataRouteById.bind(this);

    this.ckeEditorSignature = element => {
      this.signatureRef = element;
    };

    this.getEmployeeListByFilter = debounce(this.getEmployeeListByFilter.bind(this), 500); // Затримка 500 мс
  }

  async componentDidMount() {
    this.fetchDataRouteById();
    this.props.fetchRoles();
    this.props.getCustomerList();
    this.props.getAllEmployess();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.currentUser !== prevProps.currentUser && this.props.roles && this.props.customers) {
      const currentUser = path(['currentUser'], this.props);
      currentUser.customers = this.props.customers;
      if (currentUser) {
        const extraFields = {customers: customers};
        const newFields = linkDataToFields(currentUser, {...clone(this.state.fields), customers: []}, {
          type: function (current, data) {
            return this.getTypeByName(data);
          }.bind(this)
        }, extraFields);

        this.setState({
          fields: newFields,
        });
      }
    }
  }

  fetchDataRouteById() {
    const id = path(['match', 'params', 'id'], this.props);
    this.props.getDataById(id);
  }

  submitForm(e, fields) {
    e.preventDefault();
    let check = true;
    for (let field in fields) {
      if (field === 'customers') {
        if (fields[field].length) {
          const add = [];
          const remove = [];
          fields[field].forEach(item => {
            if (typeof item.customers_id.value === 'string') {
              add.push(item.customers_id.value)
            }
          });
          this.state.customer_remove_ids.forEach(item => {
            if (typeof item.relation_id) {
              remove.push(item.relation_id.value);
            }
          });
          this.setState({
            customer_remove_ids: remove,
            customer_add_ids: add
          });
        }
      } else {
        fields[field].errors = [];
        let result = approve.value(fields[field].value, fields[field].rules || {});
        if (result.errors.length > 0) {
          check = false;
          fields[field].errors = Array.from(result.errors);
        }
      }
    }
    return {
      fields,
      check,
    };
  }

  submit(e) {
    e.preventDefault();
    const signature = this.state.fields['signature'];
    if (signature) {
      signature.value = this.signatureRef.editor.getData();
    }
    let result = this.submitForm(e, this.state.fields);
    if (result.check === false) {
      this.setState({
        fields: result.fields,
      });
    } else {
      setTimeout(() => {
        this.props.saveForm(
          path(['currentUser', 'id'], this.props),
          processFields(this.state.fields),
          this.state.customer_remove_ids,
          this.state.customer_add_ids,
          Number(this.state.fields.type.value) === 3
        );
      }, 2000);
    }
    return false;
  }

  updateCustomerValue(newValue) {
    this.setState({
      selectValue: newValue
    });
  }

  getTypeByName(name) {
    const item = findByField(name, this.props.roles, 'text');

    if (item) {
      return item.value;
    }

    return '';
  }

  generatePassword(e) {
    e.preventDefault();
    this.setState(mergeDeepLeft({
      fields: {
        password: {
          value: getPassword(),
        },
      },
    }, this.state));
  }

  changeFormValue(field, newObject) {
    let stateClone = clone(this.state);
    stateClone.fields[field] = newObject;
    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  cancel() {
    this.props.goToPeople();
  }

  getEmployeeList() {
    const employeesSource = path(['employees', 'list'], this.props) || [];
    const employeeList = [];

    for (let i = 0; i < employeesSource.length; i++) {
      employeeList.push({
        value: parseInt(employeesSource[i].id),
        text: employeesSource[i].firstname + ' ' + employeesSource[i].lastname + ' (' + employeesSource[i].id + ')',
      })
    }
    employeeList.sort((a, b) => a.text.localeCompare(b.text));
    return employeeList;
  }

  loadOptions = (filter) => {
    return new Promise((resolve) => {
      this.getEmployeeListByFilter(filter)
        .then((options) => {
          resolve(options);
        })
        .catch((error) => {
          console.error("Error fetching options:", error);
          resolve([]);
        });
    });
  };

  getEmployeeListByFilter(filter = []) {
    return fetch2(`${config.apiEndpoint}/employee/search?filter=${filter}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `bearer ${store.get('user') ? store.get('user').api_token : ''}`
      },
      credentials: 'same-origin'
    })
      .then((response) => response.json())
      .then((json) => {
        const results = json.map((item) =>
            ({
              value: parseInt(item.id),
              label: this.makeLabelItem(item),
            })
        );
        return {options: results};
      })
      .catch(() => {options: []});
  }

  makeLabelItem (item) {
    return `${item.firstname} ${item.lastname} (${item.id})`;
  }

  getSelectedEmployeeValues() {
    if (this.state.fields['employee'].value === null) {
      return false;
    }
    const employee = this.getEmployeeList().find((item) => item.value === this.state.fields['employee'].value);
    if (!employee) {
      return false;
    }

    const selected =  {
        label: employee.text,
        value: parseInt(this.state.fields['employee'].value)
      }

    return selected;
  }

  parseCustomersList(arr) {
    const arrCustomers = [];

    if (arr) {
      for (let i = 0; i < arr.length; i++) {
        arrCustomers.push({
          value: arr[i].id,
          label: arr[i].name,
        });
      }
    }

    return arrCustomers;
  }

  render() {
    const customerList = this.parseCustomersList(this.props.customersList);
    const hasAccessForEdit = hasAccess({
      'permAreaKey': 'user',
      'permTypeKey': 'edit',
    });
    const id = path(['match', 'params', 'id'], this.props);
    const disableFieldForEdit = !hasAccessForEdit;
    return (
      <div className="row">
        <div className="col">
          <Breadcrumbs list={[
            {url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard'},
            {url: '/pages/people', icon: 'accessibility', name: 'People'},
            {icon: 'credit_card', name: 'Edit User'},
          ]}/>
          <div className="card rounded">
            <div className="card-header rounded-top">
              Edit User
            </div>
            <div className="card-block">
              <div className="col-12" style={{paddingBottom: '40px'}}>
                <button
                  className={'btn btn-danger btn-outline float-right'}
                  style={{marginLeft: '10px'}}
                  onClick={this.cancel}
                >
                  <i className="fa fa-remove"></i>
                  <span style={{paddingLeft: '3px'}}>Cancel</span>
                </button>
                {hasAccessForEdit &&
                <button className={'btn btn-success btn-outline float-right'} onClick={this.submit}>
                  <i className="fa fa-check"></i>
                  <span style={{paddingLeft: '3px'}}>Save & Continue</span>
                </button>
                }
              </div>
              <form onSubmit={this.submit}>
                <div className="col-12">
                  {this.props.roles && <Select
                    options={this.props.roles}
                    field={this.state.fields['type']}
                    onChange={this.changeFormValue}
                    disabled={disableFieldForEdit}
                  />}
                  <Input
                    field={this.state.fields['username']}
                    onChange={this.changeFormValue}
                    disabled={disableFieldForEdit}
                  />
                  <Input
                    field={this.state.fields['firstname']}
                    onChange={this.changeFormValue}
                    disabled={disableFieldForEdit}
                  />
                  <Input
                    field={this.state.fields['lastname']}
                    onChange={this.changeFormValue}
                    disabled={disableFieldForEdit}
                  />
                  <Input
                    field={this.state.fields['email']}
                    onChange={this.changeFormValue}
                    disabled={disableFieldForEdit}
                  />

                  <div className={'form-group'}>
                    <b><label>Employee<b style={{color: 'red'}}>*</b></label></b>
                    <AsyncCreatable
                      cacheOptions={true}
                      defaultOptions={true}
                      clearable={false}
                      placeholder='Choose employee...'
                      loadOptions={this.loadOptions}
                      minInputLength={0}
                      onChange={(item) => {
                        let stateClone = clone(this.state);
                        if (item) {
                          stateClone.fields['employee'].value = item.value;
                        } else {
                          stateClone.fields['employee'].value = null;
                        }
                        this.setState(mergeDeepLeft(stateClone, this.state));
                      }}
                      value={ this.getSelectedEmployeeValues() }
                      isValidNewOption={() => false}
                      // createOptionPosition={null}
                    />
                  </div>

                  {/*{this.props.employees &&*/}
                  {/*      <Select*/}
                  {/*        disabled={disableFieldForEdit}*/}
                  {/*        options={this.getEmployeeList()}*/}
                  {/*        field={this.state.fields['employee']}*/}
                  {/*        onChange={this.changeFormValue}*/}
                  {/*  />*/}
                  {/*}*/}

                  <Input
                    field={this.state.fields['phone']}
                    onChange={this.changeFormValue}
                    disabled={disableFieldForEdit}
                  />
                  <Input
                    field={this.state.fields['password']}
                    onChange={this.changeFormValue}
                    disabled={disableFieldForEdit}
                  />
                  <Select
                    options={[
                      {
                        value: 1,
                        label: 'Active'
                      },
                      {
                        value: 0,
                        label: 'Inactive'
                      }
                    ]}
                    field={this.state.fields['status']}
                    onChange={this.changeFormValue}
                  />
                  {hasAccessForEdit &&
                    <button className={'btn btn-default btn-outline'} style={{marginBottom: '10px'}}
                            onClick={this.generatePassword}>
                      <i className="fa fa-key"></i>
                      <span style={{paddingLeft: '3px'}}>Generate</span>
                    </button>
                  }
                  {(Number(this.state.fields.type.value) === 3) && this.state.fields['customers'] ? <DynamicFormList
                    options={customerList}
                    disabled={disableFieldForEdit}
                    list={this.state.fields['customers']}
                    onChange={this.changeFormValue}
                    fields={customers}
                    idsForRemote={this.state.customer_remove_ids}
                  /> : null}
                  <CKEditorComponent
                    field={this.state.fields['signature']}
                    refLink={this.ckeEditorSignature}
                  />
                  <br/>
                  <UserPhoto
                    userId={id}
                    field={this.state.fields['photoThumb']}
                    disabled={disableFieldForEdit}
                    canUpload={hasAccessForEdit}
                    canDelete={hasAccessForEdit}
                    onUpload={this.props.uploadPhoto}
                    onRemove={this.props.removePhoto}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    roles: state.roles.listForSelect,
    currentUser: state.users.currentUser,
    customers: state.users.customers,
    customersList: state.projects.list,
    employees: state.employees
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAllEmployess: () =>  {
      fetchAllEmployees()(dispatch)
    },
    getCustomerList: () => {
      getList()(dispatch);
    },
    fetchRoles: () => {
      fetchRolesList()(dispatch)
    },
    goToPeople: () => {
      dispatch(push('/pages/people'));
    },
    getDataById: (id) => {
      fetchUserById(id, false, true)(dispatch);
    },
    saveForm: (id, data, remove, add, isSales) => {
      updateUser(id, data, remove, add, isSales)(dispatch);
    },
    uploadPhoto: (id, img) => {
      uploadUserPhoto({id, img})(dispatch);
    },
    removePhoto: (id) => {
      removeUserPhoto(id)(dispatch);
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PeopleEdit);



// WEBPACK FOOTER //
// ./src/containers/PeopleEdit/index.js